export const formTypeOptions = [
  { value: 'SPECIAL', label: 'Special' },
  { value: 'PUBLIC', label: 'Public' },
  { value: 'MIXED', label: 'Mixed' },
];

export const formStatusOptions = [
  {
    value: 'all',
    label: 'All',
  },
  {
    value: 'active',
    label: 'Active',
  },
  {
    value: 'archived',
    label: 'Archived',
  },
];

export const notificationOptions = [
  {
    value: 'SMS',
    label: 'SMS',
  },
  {
    value: 'EMAIL',
    label: 'Email',
  },
  {
    value: 'USER_DEFAULT',
    label: 'By default (user`s original preference)',
  },
];

export const formSummaryRecipientOptions = [
  {
    value: 'all',
    label: 'All',
  },
  {
    value: 'form_initiators',
    label: 'Form Initiators',
  },
  {
    value: 'form_recipients',
    label: 'Form recipients',
  },
];

export const timeOptions = [
  { value: '8:00 AM', label: '8:00 AM' },
  { value: '9:00 AM', label: '9:00 AM' },
  { value: '10:00 AM', label: '10:00 AM' },
  { value: '11:00 AM', label: '11:00 AM' },
  { value: '12:00 PM', label: '12:00 PM' },
  { value: '1:00 PM', label: '1:00 PM' },
  { value: '2:00 PM', label: '2:00 PM' },
  { value: '3:00 PM', label: '3:00 PM' },
  { value: '4:00 PM', label: '4:00 PM' },
  { value: '5:00 PM', label: '5:00 PM' },
];

export const formSummaryShouldBeSentAfterDaysOptions = [
  {
    value: 1,
    label: '1 day',
  },
  {
    value: 2,
    label: '2 days',
  },
  {
    value: 3,
    label: '3 days',
  },
  {
    value: 7,
    label: '7 days',
  },
  {
    value: 14,
    label: '14 days',
  },
  {
    value: 30,
    label: '30 days',
  },
];

export const formSummarySendingTimesOptions = [
  {
    value: 1,
    label: 'every',
  },
  {
    value: 2,
    label: 'every 2',
  },
  {
    value: 3,
    label: 'every 3',
  },
  {
    value: 4,
    label: 'every 4',
  },
];

export const formSummarySendingValueOptions = [
  {
    value: 'daily',
    label: 'Days',
  },
  {
    value: 'weekly',
    label: 'Weeks',
  },
  {
    value: 'monthly',
    label: 'Months',
  },
];

export const formSummaryStopType = [
  {
    value: 'specific_date',
    label: 'Specific date',
  },
  {
    value: 'interval',
    label: 'Interval',
  },
];

export const formSummaryStopPeriodTimesOptions = [
  {
    value: 1,
    label: '1',
  },
  {
    value: 2,
    label: '2',
  },
  {
    value: 3,
    label: '3',
  },
  {
    value: 4,
    label: '4',
  },
];
